import { useState } from "react";
import { useAuth } from "../../../contexts/AuthContext";
import Swal from "sweetalert2";
import { UserService } from "../../services/User";

const MyProfileModal = () => {
    const { user, logout, updateUserData } = useAuth();
    const [formData, setFormData] = useState({
        name: user.name || "",
        email: user.email || "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        Swal.showLoading();
        try {

            const response = await UserService().changeDetail(formData);
            Swal.fire({
                title: "",
                text: response.data.message,
                icon: "success",
                timer: 1000
            });

            user.name = formData.name;
            updateUserData(user);
        } catch (e) {
            Swal.fire({
                title: "",
                text: e.response.data.message,
                icon: "error"
            });
        }
        Swal.hideLoading();
    };

    return (
        <>
            <div className="mb-4">
                <div className="flex justify-center mb-4">
                    <img
                        alt="Foto de perfil"
                        src={`https://ui-avatars.com/api/?name=${formData.name}&color=FFFFFF&background=3b82f6`}
                        className="user-avatar rounded-full flex items-center justify-center text-white text-2xl font-bold"
                    />
                </div>
                <div className="grid grid-cols-1 gap-4 mb-4">
                    <div>
                        <label className="block text-gray-700 mb-2">Nome de usuário</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full p-2 border border-gray-300 rounded-lg"
                        />
                    </div>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 mb-2">Email</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded-lg bg-gray-200"
                        disabled
                    />
                </div>
            </div>
            <button
                onClick={handleSubmit}
                className="btn-primary w-full py-2 px-4 text-white font-medium rounded-lg"
            >
                <i className="fas fa-save mr-2"></i> Salvar alterações
            </button>
        </>
    );
};

export default MyProfileModal;
